import { Controller } from "@hotwired/stimulus"

// Handles a 3-tier logo fallback chain for provider logos:
//   1. Primary src (logo.dev proxy via /logos/:domain)
//   2. Google favicon (data-logo-fallback-google-value)
//   3. Hide image, show icon placeholder (data-logo-fallback-icon-target)
export default class extends Controller {
  static targets = ["img", "icon"]
  static values = { google: String, tried: { type: Number, default: 0 } }

  connect() {
    // A cached image can fail before Stimulus attaches the error listener.
    if (this.hasImgTarget && this.imgTarget.complete && this.imgTarget.naturalWidth === 0) this.handleError()
  }

  handleError() {
    const tries = this.triedValue
    if (tries === 0 && this.googleValue) {
      this.triedValue = 1
      this.imgTarget.src = this.googleValue
    } else {
      this.imgTarget.classList.add("hidden")
      if (this.hasIconTarget) this.iconTarget.classList.remove("hidden")
    }
  }
}
